<template>
  <div class="relative flex h-2 w-full flex-row items-center gap-1">
    <div
      class="ease-slow-effect bg-primary h-full min-w-2 shrink-0 overflow-hidden rounded-full transition-all duration-400"
      :class="trackColorClass"
      :style="{ width: `${animatedPercentage}%` }"
    ></div>
    <div
      class="bg-secondary-container relative h-2 min-w-0 shrink grow overflow-hidden rounded-full"
      :class="backgroundColorClass"
    ></div>
    <div class="absolute right-1 h-1 w-1 rounded-full" :class="trackColorClass"></div>
  </div>
</template>
<script setup lang="ts">
  import { computed, ref, onMounted } from 'vue'

  interface Props {
    percentage: number
    color?: 'on-surface' | 'on-tertiary-container' | 'on-secondary-container'
  }

  const { percentage, color = 'on-surface' } = defineProps<Props>()

  const backgroundColorClass = computed(() => {
    if (color === 'on-tertiary-container') {
      return 'bg-tertiary/20'
    }
    if (color === 'on-secondary-container') {
      return 'bg-secondary/20'
    }
    return 'bg-surface-container-highest'
  })

  const trackColorClass = computed(() => {
    if (color === 'on-tertiary-container') {
      return 'bg-tertiary'
    }
    if (color === 'on-secondary-container') {
      return 'bg-secondary'
    }
    return 'bg-primary'
  })

  const animatedPercentage = computed(() => {
    if (animated.value) {
      return Math.min(percentage, 100)
    }
    return 0
  })

  const animated = ref(false)

  onMounted(() => {
    setTimeout(() => {
      animated.value = true
    }, 100)
  })
</script>
